import { render } from "./ImageConvert.vue?vue&type=template&id=56bc20a0"
import script from "./ImageConvert.vue?vue&type=script&lang=js"
export * from "./ImageConvert.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__